export enum InlineNoteEditorType {
  FOR_STUDENTS = 'FOR_STUDENTS',
  FOR_LIBRARY = 'FOR_LIBRARY',
  PERSONAL = 'PERSONAL',
}
